export const SELECT_JENIS_LEMBAGA = "@jenisLembaga/SELECT_USER";

export const INITIALIZE_CREATE_JENIS_LEMBAGA = "@jenisLembaga/INITIALIZE_CREATE_JENIS_LEMBAGA";

export const UPDATE_NAME = "@jenisLembaga/UPDATE_NAME";
export const UPDATE_STATUS = "@jenisLembaga/UPDATE_STATUS";

export const GET_JENIS_LEMBAGA_REQUEST = "@jenisLembaga/GET_JENIS_LEMBAGA_REQUEST";
export const GET_JENIS_LEMBAGA_SUCCESS = "@jenisLembaga/GET_JENIS_LEMBAGA_SUCCESS";
export const GET_JENIS_LEMBAGA_FAILURE = "@jenisLembaga/GET_JENIS_LEMBAGA_FAILURE";

export const GET_DETAIL_JENIS_LEMBAGA_REQUEST = "@jenisLembaga/GET_DETAIL_JENIS_LEMBAGA_REQUEST";
export const GET_DETAIL_JENIS_LEMBAGA_SUCCESS = "@jenisLembaga/GET_DETAIL_JENIS_LEMBAGA_SUCCESS";
export const GET_DETAIL_JENIS_LEMBAGA_FAILURE = "@jenisLembaga/GET_DETAIL_JENIS_LEMBAGA_FAILURE";

export const UPDATE_JENIS_LEMBAGA_REQUEST = "@jenisLembaga/UPDATE_JENIS_LEMBAGA_REQUEST";
export const UPDATE_JENIS_LEMBAGA_SUCCESS = "@jenisLembaga/UPDATE_JENIS_LEMBAGA_SUCCESS";
export const UPDATE_JENIS_LEMBAGA_FAILURE = "@jenisLembaga/UPDATE_JENIS_LEMBAGA_FAILURE";

export const CREATE_JENIS_LEMBAGA_REQUEST = "@jenisLembaga/CREATE_JENIS_LEMBAGA_REQUEST";
export const CREATE_JENIS_LEMBAGA_SUCCESS = "@jenisLembaga/CREATE_JENIS_LEMBAGA_SUCCESS";
export const CREATE_JENIS_LEMBAGA_FAILURE = "@jenisLembaga/CREATE_JENIS_LEMBAGA_FAILURE";